import { mapGetters, mapActions } from 'vuex'

import _ from 'lodash'
import { isMenuOnlineOrder } from '../../lib/v-calendar/utils/helpers'

export default {
  props: {
    disabled: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      orders: [],
      plusoneCount: 0,
      resetPlusone: false,
      timer: null,
      currentUuid: null,
      ready: false,
    }
  },
  computed: {
    ...mapGetters({
      pos: 'getPos',
      queue_number: 'getPosSelectedQueueNumber',
      table_number: 'getPosSelectedTableNumber', // current table number selected
      getPosOrdersById: 'getPosOrdersById', // get orders from table number
      products: 'getPosProducts',
      posSession: 'getPosSession',
      currency: 'getCurrency',
      getPosAddedItemCount: 'getPosAddedItemCount',
      getPosRemovedItemCount: 'getPosRemovedItemCount',
      getOrdersWithCondition: 'getOrdersWithCondition',
      posSettings: 'getPosSetting',
    }),
    use_queue () {
      return this.posSettings.queue.is_active
    },
    use_table () {
      return this.posSettings.table.is_active
    },
    filterOrders() {
      return this.getOrdersWithCondition(this.use_queue, this.use_table)
    },
  },
  methods: {
    ...mapActions([
      'setPosSection',
      'setPosSectionWith',
      'deletePosOrder',
      'setPosEditOrder',
      'setPosSelectedProduct',
      'updatePosOrder',
      'setPosLocalStorage',
      'updateOrder',
    ]),
    getProduct (sku_id) {
      let data = this.products
      for (let i in data) {
        let item = data[i]
        for (let j in item.products) {
          let product = item.products[j]
          for (let k in product.prices) {
            let sku = product.prices[k]
            if (sku.sku_id == sku_id) {
              return product
            }
          }
        }
      }
      return null
    },
    onClickEdit (order) {
      let product = this.getProduct(order.sku_id)
      // clone
      let cloneProduct = _.cloneDeep(product)
      // set new price
      this.setPrice(order.sku_id, cloneProduct, order.price)
      // set data edit
      this.setPosEditOrder(order)
      // set section
      this.setPosSectionWith({
        section: 'choose-attribute',
        data: {
          product: cloneProduct,
        },
      })
    },
    onClickDelete (order) {
      if (isMenuOnlineOrder(order)) {
        this.updateOrder({
          queueNumber: `${order.queue_number}`,
          orderId: order.order_id,
          payload: {
            status: 'deleted',
          },
        })
      }

      this.deletePosOrder(order.uuid)
    },
    setPrice (sku_id, product, newPrice) {
      for (let i in product.prices) {
        let sku = product.prices[i]
        if (sku.sku_id == sku_id) {
          sku.price = newPrice
        }
      }
      return product
    },
  },
  watch: {
    orders: function (a, b) {
      // scroll to top
      if (a.length > b.length) {
        setTimeout(() => {
          $('.wrapper-items').animate({ scrollTop: 10000 }, 0)
        }, 1)
      }
      // animated plus one
      let getOrderBeforeById = (uuid) => {
        return b.find(order => order.uuid === uuid)
      }
      a.map(x => {
        if (x.quantity > 1) {
          let y = getOrderBeforeById(x.uuid)
          if (y) {
            if (x.quantity - y.quantity == 1) {
              this.plusoneCount++
              this.currentUuid = x.uuid
            }
          }
        }
      })
    },
    'pos.orders': {
      handler: function () {
        // get oders
        this.orders = _.cloneDeep(this.getPosOrdersById({
          queue_number: this.queue_number,
          table_number: this.table_number,
        }))
        // call setPosLocalStorage
        if (this.posSession) {
          this.setPosLocalStorage({ psId: this.posSession.ps_id })
        }
      },
      deep: true,
    },
    'pos': {
      handler: function () {
        if (!this.ready) {
          return
        }
        // get oders
        this.orders = this.getPosOrdersById({
          queue_number: this.queue_number,
          table_number: this.table_number,
        })
        // call setPosLocalStorage
        if (this.posSession) {
          this.setPosLocalStorage({ psId: this.posSession.ps_id })
        }
      },
      deep: true,
    },
    plusoneCount: function (a, b) {
      clearTimeout(this.timer)

      this.resetPlusone = false

      this.timer = setTimeout(() => this.resetPlusone = true, 1000)
    },
    resetPlusone: function (a, b) {
      if (a) {
        this.plusoneCount = 0
      }
    },
    getPosAddedItemCount () {
      this.$nextTick(() => {
        const { childNodes } = this.$refs.wrapperItems
        childNodes.forEach((element, index) => {
          const isLast = index >= childNodes.length - 1
          if (isLast) {
            element.classList.add('added')
          }
        })
      })

      setTimeout(() => {
        const { childNodes } = this.$refs.wrapperItems
        childNodes.forEach((element, index) => {
          element.classList.remove('added')
        })
      }, 350)
    },
  },
  created: function () {
    this.orders = this.getPosOrdersById({
      queue_number: this.queue_number,
      table_number: this.table_number,
    })

    setTimeout(() => {
      this.ready = true
    }, 1000)
  },
}



// WEBPACK FOOTER //
// ./src/mixins/pos/orderList.js